module.exports = __webpack_public_path__ + "img/15.a9343427.png";